import React from 'react'
import { t } from '@lingui/core/macro'
import { useCountdown } from '../../hooks/useCountdown'
import styles from './TimeLeft.module.css'

interface TimeLeftProps {
    expiresAt?: string
    onExpired?: () => void
}

const TimeLeft = ({ expiresAt, onExpired }: TimeLeftProps) => {
    const [timeLeft, isExpired] = useCountdown(expiresAt || null)

    if (isExpired) {
        onExpired && onExpired()
    }

    return timeLeft && (
        <div className={`${styles.countdown} ${isExpired ? styles.countdownExpired : ''} ${styles.position}`}>
            {isExpired ? (
                t`Время истекло`
            ) : (
                t`Действительно ${formatTime(timeLeft.hours)}:${formatTime(timeLeft.minutes)}:${formatTime(timeLeft.seconds)}`
            )}
        </div>
    )
}

const formatTime = (time: number): string => {
    return time.toString().padStart(2, '0')
}

export default TimeLeft
